import React from 'react';
import PropTypes from 'prop-types';
import { Form, Select, Input } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Item } = Form;
const { Option } = Select;

const propTypes = {
  views: PropTypes.array.isRequired,
};

const ModalForm = ({ form, views }) => {
  const { getFieldDecorator } = form;
  const formLableConfig = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6, offset: 2 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  return (
    <Form>
      <Item
        {...formLableConfig}
        label={<FormattedMessage id="page.objectList.existingView" />}
      >
        {
          getFieldDecorator('copyViewId', {
            initialValue: 'none',
          })(
            <Select>
              <Option value="none">------------- None -------------</Option>
              {views.map(item => <Option value={item.id} key={item.id}>{item.view_name}</Option>)}
            </Select>
          )
        }
      </Item>
      <Item
        {...formLableConfig}
        label={<FormattedMessage id="page.objectList.viewName" />}
      >
        {
          getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: <FormattedMessage id="global.errors.required" />
              }
            ],
          })(<Input />)
        }
      </Item>
    </Form>
  );
};

ModalForm.propTypes = propTypes;

export default Form.create()(ModalForm);



// WEBPACK FOOTER //
// ./src/views/ObjectList/components/ModalForm/index.jsx